import FlashcardComponent from '@views/mnemonics/flashcards/show';

export default [
  {
    path: '/mnemonics/:categoryId?',
    name: 'mnemonics#index',
    component: () => import('@views/mnemonics/index'),
    meta: {
      header: true,
    },
  },
  {
    path: '/mnemonics/:categoryId?/:mnemonicId?',
    name: 'mnemonics#show',
    component: () => import('@views/mnemonics/show'),
    meta: {
      header: true,
    },
  },
  {
    path: '/mnemonics/:categoryId/:mnemonicId/flashcards/:flashcardId?',
    name: 'mnemonics#flashcard',
    component: FlashcardComponent,
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
];
